import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import WildixUIEvents from '../../service/WildixUIEvents';
/**
 * StateListenerRegistry provides a reliable way of detecting changes to
 * preferred layout state and dispatching additional actions.
 */
StateListenerRegistry.register(
/* selector */ state => state['features/visitors'].iAmVisitor, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* listener */ (iAmVisitor, { getState }, prevMode) => {
    if (APP.wildix.wizy && typeof prevMode !== 'undefined') {
        setTimeout(() => {
            console.warn('VISITOR_MODE');
            APP.wildix.eventEmitter.emit(WildixUIEvents.VISITOR_MODE);
        }, 50);
    }
});
